// One label's data, as typed into the form. Field names match the original pages, so the ported drawing code reads them as-is.
export type Direction = 'none' | 'up' | 'down' | 'left' | 'right';

export interface Product {
  name: string;     // Product Name
  desc: string;     // Description
  price: string;    // Price
  compare: string;  // Compare At (SALE tag when higher than the price)
  sku: string;      // SKU (also drawn as the barcode)
  ex1k: string; ex1v: string; // Extra Info "Label A: Value A"
  ex2k: string; ex2v: string; // Extra Info "Label B: Value B"
  showQR: boolean;  // Show QR Code
  qrText: string;   // QR Content
  direction: Direction; // Item Location arrow
}

// What a design is drawn from: the product (values trimmed, placeholder name filled in) plus the store name.
export interface LabelData extends Product { store: string }

export type Template = 'classic' | 'price' | 'minimal' | 'retail';
export type Orientation = 'portrait' | 'landscape';

// f(n): a font size n scaled to the label's width, never below 8 px (the letter sheets' sizing)
export type Scale = (n: number) => number;

// The 4×6 sticker's fixed type sizes per orientation + layout (see LAYOUT_TYPE in lib/sticker.ts)
export interface TypeSizes { price: number; name: number; desc: number; extra: number; sku: number; store: number; showDesc: boolean; showExtra: boolean }

export const emptyProduct = (): Product => ({ name: '', desc: '', price: '', compare: '', sku: '', ex1k: '', ex1v: '', ex2k: '', ex2v: '', showQR: true, qrText: '', direction: 'none' });

export interface PageDims { pageW: number; pageH: number; labelW: number; labelH: number; cols: number; rows: number }

// What a label maker draws from: everything chosen in the form except the per-label data.
export interface DrawOptions { orient: Orientation; layout: string; template: Template }
